module.exports = __webpack_public_path__ + "img/Design.31385505.png";